if (document.querySelector(".js-tns-video-after") !== null) {
    const videoAfterSlider = tns({
        container: ".js-tns-video-after",
        items: 1,
        slideBy: 1,
        loop: false,
        autoplay: false,
        prevButton: ".js-slider-video-after-prev",
        nextButton: ".js-slider-video-after-next",
        navContainer: ".js-nav",
        responsive: {
            500: {
                gutter: 15,
                items: 2,
            },
            960: {
                gutter: 30,
                items: 3,
            },
            1080: {
                gutter: 30,
                items: 3,
            },
        },
    });
}
if (document.querySelector(".js-tns-asside-video-week") !== null) {
    const assideVideoSliderWeek = tns({
        container: ".js-tns-asside-video-week",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                gutter: 15,
                items: 2,
            },
            960: {
                disable: true,
            },
        },
    });
}
if (document.querySelector(".js-tns-asside-video-month") !== null) {
    const assideVideoSliderMonth = tns({
        container: ".js-tns-asside-video-month",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                gutter: 15,
                items: 2,
            },
        },
    });
}

if (document.querySelector(".js-tns-last-articles") !== null) {
    const lastArticlesSlider = tns({
        container: ".js-tns-last-articles",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                gutter: 15,
                items: 2,
            },
            960: {
                disable: true,
            },
        },
    });
}

if (document.querySelector(".js-tns-thematique") !== null) {
    let thematiqueSlider = tns({
        container: ".js-tns-thematique",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                nav: false,
                center: false,
                gutter: 15,
                items: 2,
                // disable: true,
            },
            960: {
                disable: true,
            },
        },
    });
}
if (document.querySelector(".js-tns-category") !== null) {
    const categorySlider = tns({
        container: ".js-tns-category",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                gutter: 30,
                items: 2,
                loop: false,
                center: false,
                nav: false,
                // disable: true,
            },
            800: {
                disable: true,
            },
        },
    });
}
if (document.querySelector(".js-tns-more-read") !== null) {
    const moreReadSlider = tns({
        container: ".js-tns-more-read",
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false,
        controls: false,
        center: true,
        gutter: 15,
        navPosition: "bottom",
        responsive: {
            500: {
                // gutter: 15,
                // items: 2,
                gutter: 30,
                items: 2,
                loop: false,
                center: false,
                nav: false,
                // disable: true,
            },
            960: {
                disable: true,
            },
        },
    });
}
